import user from "./user";
import userDocument from "./userDocument";
import vendorDocument from "./vendorDocument";
const progress = {
    user,
    userDocument,
    vendorDocument,
};
export default progress;
